import { render } from "./FragranceDetailsForm.vue?vue&type=template&id=f2fd51b4&scoped=true"
import script from "./FragranceDetailsForm.vue?vue&type=script&lang=js"
export * from "./FragranceDetailsForm.vue?vue&type=script&lang=js"

import "./FragranceDetailsForm.vue?vue&type=style&index=0&id=f2fd51b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fd51b4"]])

export default __exports__